import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const NewLiveValueBatteryFilled: React.VFC<SvgIconProps & { stateOfCharge: number; color: string }> = ({ stateOfCharge, color, ...props }) => {
  const batteryIconWidth = 49
  const innerWidth = batteryIconWidth - 2
  const calculatedFillingWidth = Math.floor((stateOfCharge / 100) * innerWidth)

  return (
    <SvgIcon width={80} height={80} viewBox={'0 0 80 80'} {...props} fill="transparent">
      <rect x="14" y="25" height="29" width={calculatedFillingWidth} fill={color} />
      <path d="M67 34.8911V44.1089" stroke="currentColor" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" />
      <rect x="13" y="25" width={batteryIconWidth} height="29" rx="6" stroke="currentColor" strokeWidth="3" fill="transparent" />
    </SvgIcon>
  )
}
export default NewLiveValueBatteryFilled
